import React, { useEffect, useState, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../../store/actions";
import { i18n } from '../../../translate/i18n';
import { Paper, Container, IconButton, Typography, Button, Chip, Drawer, Tooltip } from "@mui/material";
import { ArrowBack, FilterList } from '@mui/icons-material';
import TableTitle from "../../../UI/MaterialTableOverrides/TableTitle";
import Card from "../../../UI/Cards/CardEquipment";
import FileDownloadButton from '../../../components/FileDownloadButton/FileDownloadButton';
import Spinner from '../../../components/Spinner/index';
import EquipmentModalFilter from '../ModalFilter/Places/index';
import EquipmamentChangeStatusInput from '../../../components/EquipmentChangeStatusInput/index';
import { formatLanguageFromLocalStorage } from "../../../utils/formatLanguageFromLocalStorage";
import confirm from "../../../UI/Confirm/confirm";
import { EAccessRole } from "../../../store/types";
import EFeatureFlags from "../../../utils/EFeatureFlags";

const ParamEquipPlaces = (props) => {
  let textInput = useRef(null);
  const dispatch = useDispatch();

  const placeId = props.match.params.id;

  // const qrCodePlaceValue = JSON.stringify({
  //   type: 'place',
  //   _id: placeId
  // })

  const [page, setPage] = useState(1);
  const [alreadySerched, setAlreadySerched] = useState(false);
  const [limit, setLimit] = useState(12);
  const [orderBy, setOrderBy] = useState("name");
  const [order, setOrder] = useState("asc");
  const [counter, setCounter] = useState(0);

	const [activeComment, setActiveComment] = useState('');
  const [showActiveCommentInput, setShowActiveCommentInput] = useState(false);

  const [maintenanceReason, setMaintenanceReason] = useState('');
  const [showMaintenanceReasonInput, setShowMaintenanceReasonInput] = useState(false);

  const [sendMaintenance, setSendMaintenance] = useState(null);
  const [sendForInactivate, setSendForInactivate] = useState(null);

  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const [exportLoading, setExportLoading] = useState(false);

  const filteredModels = useSelector(state => state.equipments.filtersByPlace.filteredModels);
  const filteredGroups = useSelector(state => state.equipments.filtersByPlace.filteredGroups);
  const filteredAreas = useSelector(state => state.equipments.filtersByPlace.filteredAreas);
  const filteredCompanies = useSelector(state => state.equipments.filtersByPlace.filteredCompanies);
  const filteredStatus = useSelector(state => state.equipments.filtersByPlace.filteredStatus);
  const selectedAccess = useSelector(state => state.auth.selectedAccess);
  const equipmentsByPlace = useSelector(state => state.equipments.equipmentsByPlace);
  const place = useSelector(state => state.places.place);
  const printerList = useSelector(state => state.print.printerList);

  const isAnalyst = selectedAccess.role === EAccessRole.analyst;
  const isContractor = selectedAccess.role === EAccessRole.contractor;
  const isInspector = selectedAccess.inspector && (isAnalyst || isContractor);
  const onlyQRServicesFeatureFlag = selectedAccess.tenant.featureFlags.includes(EFeatureFlags.BLOCK_SERVICE_CREATION_WITHOUT_QRCODE_SCANNING);
  const blockQrCodePrinting = counter.length === 0 || (onlyQRServicesFeatureFlag && (isAnalyst || isContractor));
  const blockEquipCreationInSitesWithoutAccess = selectedAccess.tenant.featureFlags.includes(EFeatureFlags.BLOCK_EQUIPMENT_CREATION_IN_SITES_WITHOUT_ACCESS)
    && place.site
    && !selectedAccess.sites.some(s => s._id === place.site);


  //quando o texto de procura estiver com algo, ao voltar, o settimeout dispara e faz uma nova consulta,
  //esta variavel é para proteger isso
  const [protectFirstSearch, setProtectFirstSearch] = useState(false);

  const searchText = useSelector(state => state.equipments.searchTextEquipmentByPlace);
  const forceReload = useSelector(state => state.equipments.dataChangedForceReload);

  // const fetchEquipmentsByPlace = useCallback((id, page, limit, searchText, order, orderBy, infiniteScroll = false) =>
  //   dispatch(actions.fetchEquipmentsByPlace(id, page, limit, searchText, order, orderBy, infiniteScroll)),
  //   [page, limit, order, orderBy]
  // );

  const localStorageLang = localStorage.getItem("i18nextLng");
  const emailLanguage = formatLanguageFromLocalStorage(localStorageLang);

  const fetchEquipmentsByPlace = useCallback(
    (page, infiniteScroll = false) => dispatch(actions.fetchEquipmentsByPlace(placeId, page, limit, searchText, order, orderBy, infiniteScroll, filteredModels, filteredGroups, filteredAreas, filteredCompanies, filteredStatus)),
    [placeId, page, limit, searchText, order, orderBy, filteredModels, filteredGroups, filteredAreas, filteredCompanies, filteredStatus]
  );

  const fetchEquipmentsExportByPlace = useCallback(
    () => dispatch(actions.fetchEquipmentsExportByPlace(placeId, searchText, filteredModels, filteredGroups, filteredAreas, filteredCompanies, filteredStatus, emailLanguage)),    
    [placeId, searchText, filteredModels, filteredGroups, filteredAreas, filteredCompanies, filteredStatus, emailLanguage]
  );

  const fetchPlace = useCallback(
    () => dispatch(actions.fetchPlacesById(placeId))
  );

  const loadingEquipments = useSelector(state => state.equipments.loading);
  const loadingInfiniteScroll = useSelector(state => state.equipments.loadingInfiniteScroll);
  const loadingPlaces = useSelector(state => state.places.loading);

  useEffect(() => {
    if (placeId === place._id) {
      if (forceReload) {
        fetchEquipmentsByPlace(page)
        dispatch(actions.setDataChangedForceReload(false))
      } else {
        const pageNow = Math.ceil(equipmentsByPlace.rows.length / limit)
        setPage(pageNow);
      }
    } else {
      dispatch(actions.setDataChangedForceReload(false))
      setProtectFirstSearch(true)
      dispatch(actions.setSearchTextEquipmentByPlace(''))
      fetchPlace();
      fetchEquipmentsByPlace(page);
    }
  }, []);

  useEffect(() => {
    setPage(1);
    fetchEquipmentsByPlace(1);
    setAlreadySerched(true);
  }, [filteredModels, filteredGroups, filteredAreas, filteredCompanies, filteredStatus]);


	useEffect(() => {
		dispatch(actions.setOpenDrawer(true))
	}, [])

  useEffect(() => {
    setAlreadySerched(true);
  }, [page, limit, order, orderBy]);

  useEffect(() => {
    if ((searchText !== "" || alreadySerched) && protectFirstSearch) {
      const timer = setTimeout(() => {
        if (searchText.normalize('NFD').replace(/[\u0300-\u036f]/g, "") === textInput.current.value.normalize('NFD').replace(/[\u0300-\u036f]/g, "")) {
          setPage(1)
          fetchEquipmentsByPlace(page);
        }
      }, 200);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [searchText, textInput]);

  useEffect(() => {
    let cont = 0;
    equipmentsByPlace.rows.map(equip => {
      if (printerList.filter(eq => eq._id === equip._id).length > 0) {
        cont++
      }
    })
    setCounter(cont);
  }, [printerList])

  useEffect(() => {
    return () => {
      const goToEquipDetails = props.history.location.pathname.split('/')[1] === 'form-equip'
      if (!goToEquipDetails) {
        handleDelete();
      }
    }
  }, []);

  const loadMore = () => {
    setPage(prev => prev + 1);
    fetchEquipmentsByPlace(page + 1, true);
  }

  const handleBack = () => {
    props.history.push('/admin-places');
  }

  const handleClickEquip = (id) => {
    props.history.push(`/form-equip/${id}/admin-equip-places/${placeId}`)
  }

  const handleDelete = () => {
    dispatch(actions.printerClearEquip())
  }

  const handleClickCheckbox = (equip) => {
    dispatch(actions.printerAddEquip(equip))
  }

  const handleSelectAll = () => {
    equipmentsByPlace.rows.map(equip => {
      if (printerList.filter(eq => eq._id === equip._id).length === 0) {
        dispatch(actions.printerAddEquip(equip))
      }
    })
  }

	const handleCloseActiveComment = () => {
    setShowActiveCommentInput(false);
  }

  const handleCloseMaintenanceReason = () => {
    setShowMaintenanceReasonInput(false);
  }

	const handleSaveActiveStatus = (ids, value) => {
		const body = {
			comment: activeComment,
			ids,
      sendForInactivate: value,
		}

    try {
			setShowActiveCommentInput(false);
      dispatch(actions.printerClearEquip());

			dispatch(actions.inactivateEquipments(body))
			
      setPage(1)
			fetchEquipmentsByPlace()
		} catch(err) {
			setShowActiveCommentInput(false);
		}
	}


  const handleMaintenanceChange = (ids, value) => {
    const body = {
			comment: maintenanceReason,
			ids,
      sendForMaintenance: value,
		}

		try {
			setShowMaintenanceReasonInput(false);
			dispatch(actions.printerClearEquip());

			dispatch(actions.maintenanceEquipments(body))
			
      setPage(1)
			fetchEquipmentsByPlace()
		} catch(err) {
			setShowMaintenanceReasonInput(false);
		}
   }


  const handleDeleteMultipleEquipments = async () => {
    let equipsSelectedIds = [];
		await printerList.map(eq => equipsSelectedIds.push(eq._id))

		const body = {
			ids: equipsSelectedIds
		}

    confirm(`${i18n.t('handleDeleteEquipment.confirm3')} \n ${i18n.t('handleDeleteEquipment.confirm2')}`,
      {
        title: `${i18n.t('handleDeleteEquipment.title2')} (${body.ids.length})`,
        titleColor: 'red',
        disableBackdrop: true
      }).then(
        () => { },
        async () => {
          dispatch(actions.printerClearEquip());

            dispatch(actions.deleteMultipleEquipments(body))
            .then(result => {
              if (result === 'success') {
                fetchEquipmentsByPlace()
              }
            })
        },
      )
      .catch(err => {
        console.log(err.message)
      })
	}

  const handleClickInactivate = () => {
		setShowActiveCommentInput(true);
	}

  const handleClickMaintenanceEquipments = () => {
		setShowMaintenanceReasonInput(true);
	}

  const handleSendForMaintenance = () => {
		setSendMaintenance(true);
	}

  const handleReturnFromMaintenance = () => {
		setSendMaintenance(false);
	}

  const handleSendForInactivate = () => {
		setSendForInactivate(true);
	}

  const handleSendForReactivate = () => {
		setSendForInactivate(false);
	}

  const deleteFilteredGroups = (group) => {
    dispatch(actions.filterEquipmentByPlaceGroupsRemove(group))
  }

  const deleteFilteredAreas = (group) => {
    dispatch(actions.filterEquipmentByPlaceAreasRemove(group))
  }

  const deleteFilteredCompanies = (company) => {
    dispatch(actions.filterEquipmentByPlaceCompaniesRemove(company))
  }

  const deleteFilteredModels = (model) => {
    dispatch(actions.filterEquipmentByPlaceModelsRemove(model))
  }

  const deleteFilteredStatus = (key) => {
		if (key.includes('invalid.')) {
			const invalidKey = key.split('.')[1];
			dispatch(actions.filterEquipmentByPlaceStatus({ ...filteredStatus, invalid: { ...filteredStatus.invalid, [invalidKey]: false } }));
		} else {
			dispatch(actions.filterEquipmentByPlaceStatus({ ...filteredStatus, [key]: false }));
		}
	};

  const clearFilterButton = () => {
    if ((filteredGroups && filteredGroups.length > 0)
      || (filteredModels && filteredModels.length > 0)
      || (filteredCompanies && filteredCompanies.length > 0)
      || (filteredAreas && filteredAreas.length > 0))
      return <Typography onClick={handleClickClearFilters} style={styles.clearFilter}>{i18n.t('clearFilterButtonManagementEquip.Typography')}</Typography>;
  };

  const renderGroupsChips = () => (filteredGroups && filteredGroups.map((group) => (<Chip
    key={group.value}
    label={group.label}
    onDelete={() => deleteFilteredGroups(group)}
    style={styles.filterChip} />)))
  const renderAreasChips = () => (filteredAreas && filteredAreas.map((area) => (<Chip
    key={area.value}
    label={area.label}
    onDelete={() => deleteFilteredAreas(area)}
    style={styles.filterChip} />)))
  const renderModelsChips = () => (filteredModels && filteredModels.map((model) => (<Chip
    key={model.value}
    label={model.label}
    onDelete={() => deleteFilteredModels(model)}
    style={styles.filterChip} />)))
  const renderCompaniesChips = () => (filteredCompanies && filteredCompanies.map((company) => (<Chip
    key={company.value}
    label={company.label}
    onDelete={() => deleteFilteredCompanies(company)}
    style={styles.filterChip} />)))
  const renderStatusChips = () => {
    let chips = [];
    if (filteredStatus && filteredStatus.valid) chips.push(<Chip
      key="valid"
      label={i18n.t('statusOptions.valid')}
      onDelete={() => deleteFilteredStatus('valid')}
      style={styles.filterChip} />)
    if (filteredStatus && filteredStatus.validWithOpenedActions) chips.push(<Chip
      key="validWithOpenedActions"
      label={i18n.t('statusOptions.validWithOpenedActions')}
      onDelete={() => deleteFilteredStatus('validWithOpenedActions')}
      style={styles.filterChip} />)
    if (filteredStatus && filteredStatus.inactive) chips.push(<Chip
      key="inactive"
      label={i18n.t('statusOptions.inactive')}
      onDelete={() => deleteFilteredStatus('inactive')}
      style={styles.filterChip} />)
    if (filteredStatus && filteredStatus.maintenance) chips.push(<Chip
      key="maintenance"
      label={i18n.t('statusOptions.maintenance')}
      onDelete={() => deleteFilteredStatus('maintenance')}
      style={styles.filterChip} />)
    if (filteredStatus && filteredStatus.invalid.inDelay) chips.push(<Chip
      key="invalid.inDelay"
      label={i18n.t('statusOptions.inDelay')}
      onDelete={() => deleteFilteredStatus('invalid.inDelay')}
      style={styles.filterChip} />)
    if (filteredStatus && filteredStatus.invalid.notDone) chips.push(<Chip
      key="invalid.notDone"
      label={i18n.t('statusOptions.notDone')}
      onDelete={() => deleteFilteredStatus('invalid.notDone')}
      style={styles.filterChip} />)
    if (filteredStatus && filteredStatus.invalid.hasActionsOpenedOrOverdue) chips.push(<Chip
      key="invalid.hasActionsOpenedOrOverdue"
      label={i18n.t('statusOptions.hasActionsOpenedOrOverdue')}
      onDelete={() => deleteFilteredStatus('invalid.hasActionsOpenedOrOverdue')}
      style={styles.filterChip} />)
    if (filteredStatus && filteredStatus.invalid.hasNoServices) chips.push(<Chip
      key="hasNoServices"
      label={i18n.t('statusOptions.hasNoServices')}
      onDelete={() => deleteFilteredStatus('invalid.hasNoServices')}
      style={styles.filterChip} />)
    return chips;
  }

  const handleClickClearFilters = useCallback(() => dispatch(actions.filterEquipmentByPlaceClear()));

  const exportExcel = () => {
    setExportLoading(true);
    fetchEquipmentsExportByPlace()
      .then(response => {
        if (response) {
          window.open(response.url, "_blank")
        }
        setExportLoading(false);
      })
      .catch(() => setExportLoading(false))
  }

  const renderPageTitle = () => {
    const path = place.path;
    const arrayPath = path.split('/');
    arrayPath.shift();
    const newTitle = arrayPath.join('/');
    return newTitle;
  }

  const equipmentsToSendToMaintenance = printerList.filter(item => (item.statusGlobal !== 'maintenance' && item.statusGlobal !== 'inactive'))
  const equipmentsToSendToMaintenanceIds = equipmentsToSendToMaintenance.map(item => item._id)

  const equipmentsToReturnFromMaintenance = printerList.filter(item => (item.statusGlobal === 'maintenance'))
  const equipmentsToReturnFromMaintenanceIds = equipmentsToReturnFromMaintenance.map(item => item._id)

  const equipmentsToInactivate = printerList.filter(item => (item.statusGlobal !== 'inactive'))
  const equipmentsToInactivateIds = equipmentsToInactivate.map(item => item._id)
  
  const equipmentsToReactivate = printerList.filter(item => (item.statusGlobal === "inactive"))
  const equipmentsToReactivateIds = equipmentsToReactivate.map(item => item._id)

  return <>
    {showActiveCommentInput && sendForInactivate &&
              <EquipmamentChangeStatusInput
                  setContent={setActiveComment}
                  handleSave={() => handleSaveActiveStatus(equipmentsToInactivateIds, true)}
                  closeModal={handleCloseActiveComment}
                  title={`${i18n.t('changeStatusInputManagementEquip.title')} (${equipmentsToInactivateIds.length})`}
                  type='inactivate'
              />}
    {showActiveCommentInput && !sendForInactivate &&
              <EquipmamentChangeStatusInput
                  setContent={setActiveComment}
                  handleSave={() => handleSaveActiveStatus(equipmentsToReactivateIds, false)}
                  closeModal={handleCloseActiveComment}
                  title={`${i18n.t('changeStatusInputManagementEquip.title2')} (${equipmentsToReactivateIds.length})`}
                  type='inactivate'
              />}
    {showMaintenanceReasonInput && sendMaintenance &&
      <EquipmamentChangeStatusInput
        setContent={setMaintenanceReason}
        handleSave={() => handleMaintenanceChange(equipmentsToSendToMaintenanceIds, true)}
        closeModal={handleCloseMaintenanceReason}
        title={`${i18n.t('equipmentChangeStatusInput.maintenanceTitleFalse')} ${i18n.t('equipmentChangeStatusInput.maintenanceTitle')} (${equipmentsToSendToMaintenanceIds.length})`}
        type='maintenance'
      />}
    {showMaintenanceReasonInput && !sendMaintenance &&
      <EquipmamentChangeStatusInput
        setContent={setMaintenanceReason}
        handleSave={() => handleMaintenanceChange(equipmentsToReturnFromMaintenanceIds, false)}
        closeModal={handleCloseMaintenanceReason}
        title={`${i18n.t('equipmentChangeStatusInput.maintenanceTitleTrue')} ${i18n.t('equipmentChangeStatusInput.maintenanceTitle')}  (${equipmentsToReturnFromMaintenanceIds.length})`}
        type='maintenance'
      />}
    <Drawer
      variant="temporary"
      anchor="right"
      onClose={() => setIsFilterOpen(false)}
      open={isFilterOpen}>
      <EquipmentModalFilter
        closeModal={() => setIsFilterOpen(false)}
      />
    </Drawer>
    <div style={{ display: 'flex', alignItems: 'flex-start' }}>
      <IconButton onClick={handleBack} style={styles.arrowBack} size="large"><ArrowBack /></IconButton>
      <Container maxWidth="lg">
        <Paper>
          <TableTitle
            title={loadingPlaces ? <Spinner size={20} /> : place.path && <div>{renderPageTitle()}</div>}
            placeholder={i18n.t('tableTitlePlaces.placeholder')}
            inputRef={textInput}
            value={searchText}
            onChange={event => {
              setProtectFirstSearch(true)
              return dispatch(actions.setSearchTextEquipmentByPlace(event.target.value))
            }}
            clickExport={exportExcel}
            downloading={exportLoading}
            addRow={() => props.history.push(`/form-equip/new/admin-equip-places/${placeId}`)}
            addRowLabel={i18n.t('tableTitleManagementEquip.addRowLabel')}
            showOptionsButton
            inactivate={() => handleClickInactivate()}
            disableSendForInactivate={equipmentsToInactivateIds.length === 0 || isInspector}
            disableSendForReactivate={equipmentsToReactivateIds.length === 0 || isInspector}
            sendForInactivate={() => handleSendForInactivate()}
            sendForReactivate={() => handleSendForReactivate()}
            sendForMaintenance={() => handleSendForMaintenance()}
            returnFromMaintenance={() => handleReturnFromMaintenance()}
            maintenanceEquipments={() => handleClickMaintenanceEquipments()}
            disableSendForMaintenanceButton={equipmentsToSendToMaintenanceIds.length === 0 || isInspector}
            disableReturnFromMaintenanceButton={equipmentsToReturnFromMaintenanceIds.length === 0 || isInspector}
            disableInactivate={printerList.length === 0}
            deleteMultipleEquipments={() => handleDeleteMultipleEquipments()}
            disableDeleteMultipleEquipments={printerList.length === 0 || isInspector}
            disableMakeServiceInMass
            hideAddButton={isInspector || blockEquipCreationInSitesWithoutAccess}
          />
          <div style={styles.equipsContainer}>
            {!loadingEquipments && equipmentsByPlace.rows.length > 0 &&
              <div style={styles.printContainer}>
                <div style={styles.labelsPrintContainer}>
                  <Chip
                    label={counter === 0 ? i18n.t('chip.label1') : `${counter} ${i18n.t('chip.label2')}`}
                    onDelete={counter === 0 ? null : handleDelete}
                    color={counter === 0 ? "default" : "secondary"}
                    variant="outlined"
                  />
                  <Typography style={styles.labelPrint} color={counter === 0 ? "inherit" : "secondary"} onClick={handleSelectAll}>{i18n.t('chip.Typography')}</Typography>
                </div>
                <Tooltip title={blockQrCodePrinting ? i18n.t('divTableTitleMat.tooltipBlockQRCode') : ''} arrow>
                  <span>
                    <FileDownloadButton type="qrcode" title={i18n.t('FileDownloadButton.title')} documentId={printerList} disabled={blockQrCodePrinting} />
                  </span>
                </Tooltip>
              </div>
            }
            <div style={styles.filterChipContainer}>
              <Button
                variant='contained'
                onClick={() => setIsFilterOpen(true)}
                style={styles.buttonFilter}>
              {i18n.t('btnFilterManagementEquip.label')}<FilterList style={styles.buttonFilterIcon} />
              </Button>
              {renderModelsChips()}
              {renderGroupsChips()}
              {renderAreasChips()}
              {renderCompaniesChips()}
              {renderStatusChips()}
              {clearFilterButton()}
            </div>
            {!loadingEquipments && equipmentsByPlace.rows.length > 0 &&
              <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '10px 20px', fontSize: 13 }}>
                {i18n.t('equipmentsByPlace.word1')} {equipmentsByPlace.rows.length} {i18n.t('equipmentsByPlace.word2')} {equipmentsByPlace.count} {i18n.t('equipmentsByPlace.word3')}{equipmentsByPlace.count > 1 ? 's' : ''}
              </div>}
            <div style={styles.cardContainer}>
              {!loadingEquipments && equipmentsByPlace && equipmentsByPlace.rows.map(equip => {
                return (
                    <Card
                      {...equip}
                      key={equip._id}
                      click={handleClickEquip}
                      checkbox={handleClickCheckbox}
                      checked={printerList.filter(eq => eq._id === equip._id).length > 0}
                    />
                )
              })}
            </div>
            {(loadingEquipments || loadingInfiniteScroll) && <Spinner overlay />}
            {(!loadingEquipments && !loadingInfiniteScroll) && (
              <div style={styles.loadMoreContainer}>
                {!loadingInfiniteScroll && equipmentsByPlace.rows.length < equipmentsByPlace.count &&
                  <Button onClick={() => loadMore()} variant='outlined'>
                    {i18n.t('btn.label')}
                  </Button>}
              </div>
            )}
            {!loadingEquipments && equipmentsByPlace.rows.length === 0 &&
              <div style={styles.spinnerContainer}>
                <Typography>{i18n.t('btn.Typography')}</Typography>
              </div>}

          </div>
        </Paper>
      </Container>
    </div>
  </>;
}

export default ParamEquipPlaces;

const styles = {
  filterChipContainer: {
    paddingLeft: 20,
    display: 'flex',
    flexWrap: 'wrap',
  },
  filterChip: {
    cursor: 'pointer',
    margin: 5,
  },
  buttonFilterIcon: {
    marginLeft: 5
  },
  buttonFilter: {
    zIndex: 200,
    backgroundColor: 'green',
    height: '2.2rem',
    width: '6.5rem',
    padding: '1rem',
    color: '#fff',
  },
  equipsContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: 10,
    position: 'relative',
    minHeight: 120,
  },
  printContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '5px 15px',
  },
  labelsPrintContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  labelPrint: {
    margin: '0 10px',
    textDecoration: 'underline',
    cursor: 'pointer',
    fontSize: 13,
  },
  cardContainer: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  loadMoreContainer: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    margin: '5px 0',
  },
  spinnerContainer: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    margin: '25px 0',
  },
  iconQrCode: {
    width: '1.5rem',
  },
  clearFilter: {
    cursor: 'pointer',
    textDecoration: 'underline',
    zIndex: 200,
    padding: '0.75rem 0.5rem',
    color: '#000',
  }
}
